import React from 'react';
import { v1 as uuid } from 'uuid';
import PaddingBox from '../../../../components/PaddingBox';
import Message from '../../../../components/Message';
import translationsCodesByErrorsCode from './translationsCodesByErrorsCode';
import { useTranslationAPI } from '../../../translations';
import errorsTranslationCodes from '../../../../data/translations/errorCodes';
import { RouteLink } from '../../../../components/RouteLink';

export const AuthenticationErrorsBox = ({ errors, isEnableDefaultErrorCode = true }) => {
	const { translate } = useTranslationAPI();
	const errorCodes = Object.keys(errors);

	const errorsList = errorCodes.map((errorKey) => {
		if (errorKey === '') {
			return errors[''];
		}

		const code = translationsCodesByErrorsCode[errorKey];

		if (!code && isEnableDefaultErrorCode) {
			return translate(translationsCodesByErrorsCode.default);
		}

		if (errorKey === 'loginCooldown') {
			return translate(code, [errors.loginCooldown.timeToWait]);
		}

		if (errorKey === 'passwordNotUnique') {
			return translate(code, [errors.passwordNotUnique.uniquePasswordsCount]);
		}

		if (errorKey === 'weakPassword') {
			return translate(code);
		}

		if (errorKey === 'blockedUserByAccessRequest') {
			return (
				<>
					{translate(code)}{' '}
					<RouteLink
						hasColor
						href={errors[errorKey].platformurl}
						target='_blank'
						noUnderline={false}
					>
						{translate(errorsTranslationCodes.requestAccess)}
					</RouteLink>
				</>
			);
		}

		return translate(code);
	});

	if (errorsList.length === 1 && !errorsList[0]) {
		return null;
	}

	return (
		<PaddingBox bottomSmall>
			<Message status='danger'>
				{errorsList.map((item) => (
					<div key={uuid()}>{item}</div>
				))}
			</Message>
		</PaddingBox>
	);
};
